// CoursesPanel/index.js
import { connect } from 'react-redux';
import CoursesPanel from '../../components/CoursesPanel';

import {
  searchTermChangeForAllCoursesDispatch,
  openCreateCourseDialogDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.course.newCourse.showEditCourseDialog,
    openPanel: state.course.newCourse.showEditCoursePanel,
    searchTerm: state.courses.coursesByBranch.searchTerm
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    handleSearchTermChange: (searchTerm) => {
      dispatch(searchTermChangeForAllCoursesDispatch(searchTerm));
    },
    openCreateCourseDialog: (open) => {
      dispatch(openCreateCourseDialogDispatch(open));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CoursesPanel);
